import clsxm from '@/lib/clsxm';

import Link, { LinkProps, LinkVariant } from '@/components/link';
import Typography, { TypographyColor } from '@/components/typography';

import {
  BackgroundColor,
  backgroundColorToColorNameMap,
} from '@/enums/background-color';

export type CTAProps = {
  title: string;
  text?: string;
  link: LinkProps;
  full?: boolean;
  backgroundColor?: BackgroundColor;
};

export const defaultCTAProps: Required<
  Pick<CTAProps, 'full' | 'backgroundColor'>
> = {
  full: false,
  backgroundColor: BackgroundColor.WHITE,
};

export default function CTA({
  title,
  text,
  link,
  full = defaultCTAProps.full,
  backgroundColor = defaultCTAProps.backgroundColor,
}: CTAProps) {
  return (
    <div
      className={clsxm(
        'flex flex-col items-center justify-between rounded-2xl text-center shadow',
        'w-full gap-4 p-6 md:flex-row md:gap-6 md:px-12',
        !full && 'sm:mx-auto sm:w-11/12 md:w-10/12 lg:w-8/12',
        backgroundColorToColorNameMap[backgroundColor]
      )}
    >
      <div className='flex flex-col gap-1'>
        <Typography.Heading5
          color={TypographyColor.DEFAULT}
          className='text-center text-typography-dark md:text-left'
        >
          {title}
        </Typography.Heading5>
        <Typography.Body2
          color={TypographyColor.DEFAULT}
          className='text-center text-typography-dark md:text-left'
        >
          {text}
        </Typography.Body2>
      </div>

      {link && (
        <Link
          {...link}
          variant={link.variant || LinkVariant.PRIMARY_BUTTON}
          className={clsxm('whitespace-nowrap', link.className)}
        />
      )}
    </div>
  );
}
